<template>
  <div class="col-xs-12 col-sm-10 col-sm-offset-1">
    <div class="row second">
      <form class="form-inline" v-on:submit.prevent="getStatistics">
        <div class="form-group">
          <label>Frequency</label>
          <select v-model="period" class="form-control">
            <option value="weekly">Weekly</option>
            <option value="monthly">Monthly</option>
            <option value="yearly">Yearly</option>
          </select>
        </div>
        <div class="form-group">
          <label >Number of records</label>
          <input type="number" class="form-control" v-model.number="last" />
        </div>
        <button type="submit" class="btn btn-primary">Search</button>
      </form>
    </div>
    <br/><br/>
    <div class="row">
      <div class="col-xs-12">
        <form class="form-inline">
        <div class="form-group">
          <label>Chart</label>
          <select v-model="currentChart" class="form-control">
            <option value="1">Caller Conversion</option>
            <option value="2">Caller Acquisition</option>
            <option value="3">Referral Acquisition</option>
          </select>
        </div>
      </form>
      </div>
    </div>
    <br/><br/>
    <div class="loader" v-if="loading">
      <img src="/static/img/loader.gif" />
    </div>

    <div class="chart-responsive" >
      <chartjs-line v-if="!loading && currentChart=='1'" :labels="labels" :datasets="callerConversion" :bind="true"></chartjs-line>
    </div>

    <div class="chart-responsive" >
      <chartjs-line v-if="!loading && currentChart=='2'" :labels="labels" :datasets="callerAcquisition" :bind="true"></chartjs-line>
    </div>

    <div class="chart-responsive">
      <chartjs-line v-if="!loading && currentChart=='3'" :labels="labels" :datasets="referralAcquisition" :bind="true"></chartjs-line>
    </div>
  </div>
</template>

<script>
import api from '../../../utils/api'

export default {
  name: 'channel-stats',
  data () {
    return {
      loading: true,
      labels: [],
      period: 'weekly',
      last: 7,
      currentChart: '1',
      callerConversion: [],
      callerAcquisition: [],
      referralAcquisition: []
    }
  },
  methods: {
    makeRequestForEachChannel (allChannels) {
      const allPromises = []
      const emptyReport = {reach: 0, spend: 0, impressions: 0, action: 0}
      allChannels.forEach((channel) => {
        const channelStats = new Promise((resolve, reject) => {
          api.buildRequest(`report?period=${this.period}&last=${this.last}&channel=${channel._id}`, 'get')
            .then((res) => {
              api.buildRequest(`channel/statistics?period=${this.period}&last=${this.last}&channel=${channel.name}`, 'get')
                .then((statsResponse) => {
                  let { payload } = res.data
                  payload = payload.map((each, index) => {
                    each.referrals = statsResponse.data.payload.result[index].totalReferral
                    each.sessions = statsResponse.data.payload.result[index].totalSessions
                    each = each.report.length ? { ...each, ...each.report[0] } : { ...each, ...emptyReport }
                    return each
                  })
                  resolve(payload)
                }).catch((e) => {
                  console.log(e)
                  reject(false)
                })
            }).catch(() => {
              reject(false)
            })
        })
        allPromises.push(channelStats)
      })
      return Promise.all(allPromises)
    },
    getAccountStats (allChannels) {
      return Promise.all(allChannels.map(async (eachChannel) => await api.buildRequest(`report`)))
    },
    generateColor () {
      const r = Math.floor(Math.random() * 255)
      const g = Math.floor(Math.random() * 255)
      const b = Math.floor(Math.random() * 255)
      return `rgb(${r}, ${g}, ${b})`
    },
    getChannelData (type, last) {
      this.loading = true
      this.resetData()
      api.buildRequest('channel', 'get')
        .then(async (response) => {
          const { payload } = response.data
          let channelResponse
          try {
            channelResponse = await this.makeRequestForEachChannel(payload)
          } catch (error) {
            console.error(error)
            this.loading = false
            return
          }
          this.populateLabels(channelResponse[0])
          channelResponse.forEach((aChannel, index) => {
            const color = this.generateColor()
            this.callerConversion.push({
              label: payload[index].name,
              borderWidth: 2,
              data: this.getValuesOfaProperty(aChannel, 'sessions', 'reach'),
              borderColor: color,
              lineTension: 0.1,
              backgroundColor: color,
              fill: false
            })

            this.callerAcquisition.push({
              label: payload[index].name,
              borderWidth: 2,
              data: this.getValuesOfaProperty(aChannel, 'spend', 'sessions'),
              borderColor: color,
              lineTension: 0.1,
              backgroundColor: color,
              fill: false
            })

            this.referralAcquisition.push({
              label: payload[index].name,
              borderWidth: 2,
              data: this.getValuesOfaProperty(aChannel, 'spend', 'referrals'),
              borderColor: color,
              lineTension: 0.1,
              backgroundColor: color,
              fill: false
            })
          })
          this.loading = false
        })
    },
    getValuesOfaProperty (theChannelData, numerator, denominator) {
      const dataRecord = []
      for (let i = theChannelData.length - 1; i >= 0; i--) {
        dataRecord.push(theChannelData[i][denominator] ? theChannelData[i][numerator] / theChannelData[i][denominator] : 0)
      }
      return dataRecord
    },
    populateLabels (data) {
      for (let i = data.length - 1; i >= 0; i--) {
        this.labels.push(data[i].display)
      }
    },
    getStatistics () {
      this.getChannelData(this.period, this.last)
    },
    resetData () {
      this.labels = []
      this.callerAcquisition = []
      this.referralAcquisition = []
      this.callerConversion = []
    },
    computeTotal (value) {
      let counter = 0
      for (let key in this.total) {
        this.total[key] += value[counter]
        counter++
      }
    }
  },

  mounted () {
    this.getChannelData(this.period, this.last)
  }
}
</script>

<style>
  .second {
    margin-top: 100px;
  }

  .chart-title {
    text-align: center;
  }
</style>




// WEBPACK FOOTER //
// ChannelStats.vue?43f22660